import { SCREENING_BROWNOUT_UPDATE } from '../constants/actionTypes';

export function updateScreeningBrownoutMessage(screeningBrownoutMessage) {
  return { type: SCREENING_BROWNOUT_UPDATE, payload: { screeningBrownoutMessage } };
}
